module.exports = __webpack_public_path__ + "img/icon_reset.560a9c27.png";